module.exports = __webpack_public_path__ + "static/media/postgre_lock.d3c4d01b.png";